<template>
    <div class="mainPage">
        <div class="agentTip" v-if="!isChrome">
            <span>建议使用Chrome浏览器，以获得最佳体验</span>
            <div class="closeTip" @click="isChrome = true">×</div>
        </div>
        <div class="header_banner">
            <ztHeader>
                <div slot="logincon" class="loginWrapper">
                    <div v-if="!isLogin">
                        <span @click="toLogin()">{{ $t('message.login') }}</span> | 
                        <span @click="toLogin()">{{ $t('message.register') }}</span>
                    </div>
                    <div v-if="isLogin">
                        <span><span>{{user.username}}</span><span @click="toLogOut()">{{ $t('message.logout') }}</span> </span>
                    </div>
                </div>
          </ztHeader>
          <div class="infoCon">
            <img src="../img/cio/cio_banner.png" alt="" class="banner">
            <div class="menu" @click="showMemu = !showMemu">
                {{currentMenu}}
                <span class="caret" :class="{'activeCaret': showMemu}"></span>
                <div class="menuList"  :class="{'menuActive': showMemu}">
                    <span :class="{'active': currentMenu == 2021}" @click="changePage(2021)">2021</span>
                    <span :class="{'active': currentMenu == 2020}" @click="changePage(2020, 'https://z.chineseplus.net/cio_classlive.html')">2020</span>
                </div>
            </div>
            <!-- <div class="info">
                <div class="infoName">
                    <div class="name">
                        {{subject_info.name}}
                    </div>
                    <div class="name_en" v-if="subject_info.name_en">
                        {{subject_info.name_en}}
                    </div>
                </div>
            </div> -->
          </div>
        </div>
        <div class="tabCon">
            <div>
                <div class="tabBtn" :class="{'activeTab': activeTab == 0}" @click="changeTab(0)">
                    <div>全部课程</div>
                    <div>All Courses</div>
                </div>
                <div class="tabBtn" :class="{'activeTab': activeTab == 6}" @click="changeTab(6)">
                    <div>《HSK标准课程2》 </div>
                    <div>HSK Standard Course- Level 2</div>
                </div>
                <div class="tabBtn" :class="{'activeTab': activeTab == 7}" @click="changeTab(7)">
                    <div>《HSK标准课程3》 </div>
                    <div>HSK Standard Course- Level 3</div>
                </div>
                <div class="tabBtn" :class="{'activeTab': activeTab == 4}" @click="changeTab(4)">
                    <div>汉语口语速成—入门篇</div>
                    <div>SHORT-TERM SPOKEN CHINESE—Threshold</div>
                </div>
                <div class="tabBtn" :class="{'activeTab': activeTab == 5}" @click="changeTab(5)">
                    <div>汉语口语速成—基础篇</div>
                    <div>SHORT-TERM SPOKEN CHINESE—Elementary</div>
                </div>
                <div class="tabBtn" :class="{'activeTab': activeTab == 1}" @click="changeTab(1)">
                    <div>《HSK标准会话教程1》</div>
                    <div> HSK Standard Conversation Course-Level 1</div>
                </div>
                <div class="tabBtn" :class="{'activeTab': activeTab == 3}" @click="changeTab(3)">
                    <div>国际中文在线教学组织技巧及课堂管理方法</div>
                    <div>International Chinese Online Education Pedagogy and Classroom Management</div>
                </div>
                <div class="tabBtn" :class="{'activeTab': activeTab == 2}" @click="changeTab(2)">
                    <div>《HSK标准课程4》下册 </div>
                    <div>HSK Standard Course- Level 4 (Ⅱ)</div>
                </div>
                
            </div>
        </div>
        <div class="courseListCon">
            
            <ul class="list">
                <li v-for="(item, index) in courseList" :key="item.id" :class="{'live': item.customStatus == 1, 'finished': item.customStatus == 2}" v-show="activeTab == 0 || (item.category == activeTab&&activeTab != 0)">
                    <div class="timeCon" >
                        <span class="time">{{new Date(+item.start_time).Format('YYYY.MM.DD hh:mm')}}-{{new Date(+item.end_time).Format('hh:mm')}}</span>
                        <span class="status live" v-if="item.customStatus == 1">
                            Live 直播进行中
                        </span>
                        <span class="status finished" v-if="item.customStatus == 2">
                            Finished 直播已结束
                        </span>
                    </div>
                    <div class="nameCon">
                        <div class="name" v-if="item.name">
                            <span>
                                {{item.name}}
                            </span>
                        </div>
                        <div class="name name_en" v-if="item.name_en">
                            <span>
                                {{item.name_en}}
                            </span>
                        </div>
                    </div>
                    <div class="titleCon">
                        <div class="title">
                            <div class="en" v-if="item.teacher_name_en">
                                {{item.teacher_name_en}}
                            </div>
                            <div class="cn" v-if="item.teacher_name">
                                {{item.teacher_name}}
                            </div>
                        </div>
                        <div class="liveBtn">
                            <span class="join" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == false" @click="join(item, index, false)">
                                <span class="En">
                                    Join
                                </span>
                                <span class="Cn">
                                    加入
                                </span>
                            </span>
                            <span class="join replay" v-if="item.status == 3" @click="replay(item.video_url)">
                                <span class="En">
                                    Replay
                                </span>
                                <span class="Cn">
                                    课程回放
                                </span>
                            </span>
                            <span class="isOrder" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == true">
                                直播未开始 Coming Soon
                            </span>
                            <span class="join" v-if="item.status == 1 && item.customStatus == 1" @click="joinToLive(item, index)">
                                <span class="En">
                                    Enter
                                </span>
                                <span class="Cn">
                                    进入
                                </span>
                            </span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- <div class="guideModel" v-if="isShowGuide">
            <div class="close" @click="isShowGuide = false">×</div>
            <a href="https://z.chineseplus.net/dist/#/pcpage/guide" target="_blank"><img src="../img/cio/chineseplus_guide.png" alt=""></a>
        </div> -->
        <pcfooter></pcfooter>
        <transition name="fade">
            <div id="videoPlayWrapper" v-if="isPlay">
                <div class="videoContent">
                <div class="closeVideo" @click="closeVideo()">×</div>
                <div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" controls controlsList="nodownload"></video></div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Qs from 'qs'
import ztHeader from './ztHeader'
import pcfooter from './footer'
export default {
    name: 'chinesebridge',
    components: {
      ztHeader,
      pcfooter
    },
    data: function () {
        return {
            showMemu: false,
            currentMenu: 2021,
            isChrome: true,
            isLogin: false,
            isPlay: false,
            currentVideoUrl: '',
            user: {
                username: '',
                email: ''
            },
            isShowGuide: true,
            subject_info: {},
            courseList: [],
            activeTab: 0,
            subject_id: null,
            beforeTime: 30, // 提前可进入直播间时间
            afterTime: 30 // 延后关闭直播间时间
        }
    },
    methods: {
        changePage(page, url) {
            // this.currentMenu = page
            if(url) {
                window.open(url); 
            }
        },
        changeTab(tab) {
            this.activeTab = tab
        },
        tolive (url) {
            window.open(url)
        },
        toLogin() {
            window.location.href =
            this.baseUrl +
            "user/api/login?" +
            "callback=" +
            encodeURIComponent(window.location.href);
        },
        toRegister() {
            window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
        },
        customCheckLogin() {
            this.checkLogin().then(res => {
                if(res.data.success){
                    this.isLogin = true
                    this.user = res.data.data
                } else {
                    this.isLogin = false
                }
                this.getCourseInfo(this.subject_id)
            }).catch((r) => {
                console.log(r)
            })
        },
        toLogOut() {
            this.$utils.get('/user/api/logout').then(res => {
                if(res.data.success) {
                    this.isLogin = false
                }
            })
        },
        // 获取专题信息
        getSubjectInfo(id) {
            this.$utils.get('/subject/subject/read', {
                id: id
            }).then(res => {
                if(res.data.success) {
                    this.subject_info = res.data.data
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        // 获取课程列表
        getCourseInfo(id) {
            this.$utils.get('/subject/lesson/getlist', {
                subject_id: id,
                limit: 200
            }).then(res => {
                if(res.data.success) {
                    var now = new Date().getTime()
                    var endTime = now - this.afterTime * 60 * 1000;
                    var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                    res.data.data.list.forEach(e => {
                        e.isOrder = false
                        e.customStatus = 0
                        if (nowBeforeFiveMin > e.start_time) {
                            e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                        }
                        if (endTime > e.end_time) {
                            e.customStatus = 2
                        }
                    })
                    this.courseList = res.data.data.list
                    this.categoryName()
                    console.log(this.courseList)
                    this.checkOrdeList()
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        categoryName() {
            this.courseList.forEach(e => {
                if(e.name.indexOf('HSK标准会话教程1') > -1) {
                    e.category = 1
                }else if(e.name.indexOf('HSK标准课程4') > -1) {
                    e.category = 2
                }else if(e.name.indexOf('汉语口语速成—入门篇') > -1) {
                    e.category = 4
                }else if(e.name.indexOf('汉语口语速成—基础篇') > -1) {
                    e.category = 5
                }else if(e.name.indexOf('HSK标准课程2') > -1) {
                    e.category = 6
                }else if(e.name.indexOf('HSK标准课程3') > -1) {
                    e.category = 7
                }else {
                    e.category = 3
                }
            })
        },
        // 检查可预约直播间
        checkOrdeList() {
            const orderRoomId = []
            this.courseList.forEach(e => {
                if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                    orderRoomId.push(e.room_id)
                }
            })
            this.checkRoomsIsOrder(orderRoomId)
        },
        // 检查用户直播间状态
        checkRoomsIsOrder(arr) {
            const data = Qs.stringify({
                rooms: arr.toString(),
                user: this.user.email
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/get_user_rooms'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList.forEach((e, index) => {
                        if (res.data.data.hasOwnProperty(e.room_id)) {
                            this.courseList[index].isOrder = true
                            this.$set (this.courseList, index, this.courseList[index])
                        }
                    })
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        join(item, index, islive) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            const data = Qs.stringify({
                room_id: item.room_id,
                user: this.user.email,
                secret: "03198325b8b61ccc3413cf7e754febea",
                key: "zyz",
                username: this.user.username,
                realname: this.user.username
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/add_user'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList[index].isOrder = true
                    this.$set (this.courseList, index, this.courseList[index])
                    if (islive) {
                        window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
                    }
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        joinToLive(item, index) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            if(!item.isOrder) {
                this.join(item, index, true)
            }else {
                window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            }
        },
        replay(url) {
            this.isPlay = true
            this.currentVideoUrl = url
            setTimeout(function() {
                $('#liveVideo').bind('contextmenu',function() { return false; })
            }, 50)
        },
        closeVideo() {
            var myvideo = document.getElementById("liveVideo");
            if (!myvideo.paused) {
                myvideo.pause();
            }
            this.isPlay = false
        },
        checkChrome() {
            var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
            if (!isChrome) {
                this.isChrome = false
            }
        }
    },
    mounted() {
        // this.subject_id = this.$route.query.id
        this.subject_id = 116 // 停课不停学固定id：116
        this.customCheckLogin()
        this.getSubjectInfo(this.subject_id)
        this.checkChrome()
        let activeTab = this.$route.query.tab
        if(activeTab) {
            this.activeTab = activeTab
        }
        
    }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">

.mainPage {
    width: 100%;
    text-align: center;
    position: relative;
    min-height: 100%;
    
    .agentTip {
        width: 100%;
        height: 70px;
        line-height: 70px;
        background-color: #ffe6a1;
        text-align: center;
        position: absolute;
        z-index: 5;
        color: #c40000;
    }
    .agentTip .closeTip {
        position: absolute;
        right: 24px;
        top: 0px;
        font-size: 30px;
        color: #282828;
        cursor: pointer;
    }
    .loginWrapper {
        font-size: 16px;
        color: #fff;
        display: inline-block;
        margin-left: 20px;
        cursor: pointer;
        span {
            margin: 0 5px;
            cursor: pointer;
        }
    }.loginWrapper {
        font-size: 16px;
        color: #fff;
        display: inline-block;
        margin-left: 20px;
        cursor: pointer;
        span {
            margin: 0 5px;
            cursor: pointer;
        }
    }
    .infoCon {
        position: relative;
        .menu {
            position: absolute;
            top: 0;
            left: 20%;
            display: inline-block;
            padding: 8px 8px 10px 8px;
            border-radius: 0 0 10px 10px;
            color: #fd9c29;
            // font-weight: bold;
            font-size: 22px;
            background-color: #fff;
            cursor: pointer;
            .caret {
                display: inline-block;
                width: 0;
                height: 0;
                margin-bottom: 3px;
                margin-left: 3px;
                vertical-align: middle;
                border-top: 6px dashed;
                border-top: 6px solid\9;
                border-right: 6px solid transparent;
                border-left: 6px solid transparent;
                opacity: .9;
            }
            .activeCaret {
                border-top: none;
                border-bottom: 6px dashed;
            }
            .menuList {
                position: absolute;
                width: 100%;
                top: 42px;
                font-size: 18px;
                left: 0;
                color: #282828;
                font-weight: normal;
                background-color: #fff;
                border-radius: 10px 10px 4px 4px;
                box-shadow: 0 2px 12px 0 rgba(0,0,0,0.2);
                transition: all linear 0.2s;
                height: 0;
                overflow:hidden;
                span {
                    display: block;
                    padding: 10px 8px 10px 8px;
                    border-bottom: 1px solid #ccc;
                }
                .active {
                    color: #fd9c29;
                }
            }
            .menuActive {
                height: 78px;
            }
        }
        .banner {
        width: 100%;
        //   height: 250px;
        }
        .info {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 1200px;
            left: 0;
            right: 0;
            margin: auto;
            text-align: left;
            .infoName {
            width: 75%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            .name {
                font-size:38px;
                color: #fff;
                font-weight: bold;
                line-height:1.2;
            }
            .name_en {
                font-size: 30px;
                color: #fff;
                font-family: Georgia;
                margin-top: 20px;
            }
            }
        }
    }
    .tabCon {
        width: 100%;
        height: 100px;
        background-color:#fff;
        box-shadow: 0px 3px 5px 0px 
		rgba(0, 0, 0, 0.1);
        >div {
            // width: 1200px;
            margin: auto;
            padding: 0 30px;
            height: 100%;
            white-space: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
        }
        .tabBtn {
            display: inline-block;
            margin-top: 30px;
            margin-right: 15px;
            cursor: pointer;
            div:first-child {
                font-size: 22px;
                margin-bottom: 5px;
            }
            div:last-child {
                font-size: 14px;
                font-family: "DIN-Regular";
            }
        }
        .activeTab {
            position: relative;
            color: #f56821;
            :after {
                position: absolute;
                bottom: -30px;
                left:0;
                right: 0;
                margin: auto;
                display:inline-block;
                content: '';
                width: 70%;
                height: 6px;
                background-color: #f56821;
            }
        }
    }
    .courseListCon {
        width: 1200px;
        min-height: 400px;
        margin:30px auto 30px;
        background-color:#fff;
        .liveClass {
            padding-top: 60px;
            margin-bottom: 58px;
        }
        .list {
            position: relative;
            padding: 0 50px;
            text-align: left;
            &:before {
                position: absolute;
                left: 62px;
                width: 5px;
                height: calc(100% + 66px);
                content: '';
                background-color: #fd9c29;
            }
            li {
                margin-left: 47px;
                margin-bottom: 66px;
                position: relative;
                &:before {
                    position: absolute;
                    left: -47px;
                    top: -6px;
                    content: '';
                    width: 30px;
                    height: 30px;
                    box-sizing: border-box;
                    border-radius: 50%;
                    border: 5px solid #fd9c29;
                    background-color: #fad46b;
                }
                .timeCon {
                    .time {
                        font-size: 24px;
                        color: #5e696d;
                        font-family: "DIN-Medium";
                    }
                    .live {
                        font-size: 16px;
                        color: #379346;
                        margin-left: 60px;
                    }
                    .finished {
                        font-size: 16px;
                        color: #93a4aa;
                        margin-left: 60px;
                    }
                }
                .nameCon {
                    margin-top: 31px;
                    margin-bottom: 28px;
                    .name {
                        font-size: 30px;
                        line-height: 1.2;
                        color: #364347;
                        width: 924px;
                    }
                    .name_en {
                        font-size: 24px;
                        line-height: 1.2;
                        color: #93a4aa;
                        margin-bottom: 8px;
                        font-family: 'Georgia';
                        width: 924px;
                    }
                }
                .titleCon {
                    .title {
                        color: #fd9c29;
                        display: inline-block;
                        .en {
                            font-size: 24px;
                            font-family: 'Georgia';
                            margin-bottom: 2px;
                            width: 800px;
                            line-height: 1.2;
                        }
                        .cn {
                            font-size: 18px;
                            width: 800px;
                            line-height: 1.2;
                        }
                    }
                    .liveBtn {
                        float: right;
                        display: inline-block;
                        font-family: 'Georgia';
                        color: #282828;
                        .join {
                            display: inline-block;
                            height: 50px;
                            line-height: 1.2;
                            border-radius: 25px;
                            background-color: #fd9c29;
                            color: #fff;
                            padding: 15px 31px;
                            box-sizing: border-box;
                            cursor: pointer;
                            .En {
                                font-size: 22px;
                                vertical-align: top;
                            }
                            .Cn {
                                font-size: 20px;
                                vertical-align: top;
                            }
                        }
                        .replay {
                            background-color: #4a88da;
                            color: #fff;
                        }
                        .isOrder {
                            color: #999;
                        }
                    }
                }
            }
            .live:before {
                background-color: #43fd61;
            }
            .finished:before {
                background-color: #d6e1e5;
            }
        }
    }
    .guideModel {
        position: fixed;
        right: 0;bottom: 40px;
        z-index: 5;
        cursor: pointer;
        .close {
            font-size: 28px;
            position: absolute;
            top: 15px;right: 15px;
            color: #fff;
            cursor: pointer;
        }
    }
    #videoPlayWrapper {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 999;
    }
    #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
    }
    .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .videoContainer {
        text-align: center;
        width: 100%;
    }
    .videoContainer video {
        width: 62%;
    }
    video::-internal-media-controls-download-button {
        display:none;
    }
    video::-webkit-media-controls-enclosure {
        overflow:hidden;
    }
    video::-webkit-media-controls-panel {
        width: calc(100% + 30px);
    }
}

</style>
